import { render, staticRenderFns } from "./amt_member.vue?vue&type=template&id=c48f9d3c&scoped=true"
import script from "./amt_member.vue?vue&type=script&lang=js"
export * from "./amt_member.vue?vue&type=script&lang=js"
import style0 from "./amt_member.vue?vue&type=style&index=0&id=c48f9d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48f9d3c",
  null
  
)

export default component.exports